export const  school = [
    {
        path:'school/config-print',
        component:()=>import('@/views/schoolconfig/SchoolPrintConfig.vue')
    },
    {
        path: 'school/infor',
        component: () => import('@/views/schoolconfig/SchoolInfor.vue')
    },
    {
        path: 'school/config',
        component: () => import('@/views/schoolconfig/SchoolConfiguration.vue')
    },
    {
        path: 'school/configNew',
        component: () => import('@/views/schoolconfig/SchoolConfigurationNew.vue')
    },
    {
        path: 'school/config-class',
        component: () => import('@/views/schoolconfig/AbsentConfigClass.vue')
    },
    {
        path: 'school/config-common',
        component: () => import('@/views/schoolconfig/ConfigCommon.vue')
    },
    {
        path: 'school/config-employee',
        component: () => import('@/views/schoolconfig/SchoolConfigAttendanceEmployee.vue')
    },
    {
        path: 'school/camera',
        component: () => import('@/views/schoolconfig/camera/CameraConfig.vue')
    },
    {
        path: 'school/camera-school',
        component: () => import('@/views/schoolconfig/camera/CameraSchool.vue')
    },

    {
        path: 'school/icon-app',
        component: () => import('@/views/schoolconfig/iconApp/IconAppSchoolConfig.vue')
    },

    {
        path: 'school/chat-group',
        component: () => import('@/views/schoolconfig/chat/ConfigRoleUserAppChat.vue')
    },


    {
        path: 'school/media',
        component: () => import('@/views/schoolconfig/MediaConfig.vue')
    },
    {
        path: 'school/subject',
        component: () => import('@/views/schoolconfig/SubjectManagement.vue')
    },
    {
        path: 'school/notification-manage',
        component: () => import('@/views/schoolconfig/notification/ViewContentNotification.vue')
    },
    {
        path: 'school/birthday-sample',
        component: () => import('@/views/schoolconfig/BirthdaySampleConfig.vue')
    },
    {
        path: 'school/evaluate-sample',
        component: () => import('@/views/schoolconfig/EvaluateSampleConfig.vue')
    },
    {
        path: 'school/attendance-sample',
        component: () => import('@/views/schoolconfig/AttendanceSampleConfig.vue')
    },
    {
        path: 'school/wish-sample',
        component: () => import('@/views/schoolconfig/WishSampleConfig.vue')
    },
    {
        path: 'school/account-type',
        component: () => import('@/views/schoolconfig/account/AccountType.vue')
    },
    {
        path: 'school/permission-manage',
        component: () => import('@/views/schoolconfig/roleApi/UserRoleConfig.vue')
    },
    {
        path: 'school/config-fuction',
        component: () => import('@/views/schoolconfig/ConfigFunction.vue')
    },
    {
        path: 'school/permission-manage-for-supperPlus',
        component:() => import('@/views/master/school/CreateDataSystemForSchool')
    },
    {
        path: 'school/config-template-app',
        component:() => import('@/views/master/school/templateApp/ConfigTemplateApp.vue')
    },
    {
        path: 'school/config-ticket-app',
        component:() => import('@/views/master/school/templateApp/ConfigTicketApp.vue')
    },
    {
        path: "school/recognition-manager",
        component: () => import('@/views/master/school/RecognitionManager.vue')
    },

    {
        path: 'school/config-chat',
        component:() => import('@/views/master/school/chat/ConfigRoleUserChatForPlus.vue')
    },

    {
        path: "school/bank-connection-manager",
        component: () => import('@/views/sepay/BanksConnectionSchool.vue')
    },
    {
        path: "school/bank-connection-manager/v2",
        component: () => import('@/views/sepay/BanksConnectionSchoolVersion2.vue')
    },
    {
        path: "school/bank-transaction-statistics-school",
        component: () => import('@/views/sepay/BankTransactionStatisticsSchool.vue')
    },
    {
        path: "school/transaction-volume-chart-school",
        component: () => import('@/views/sepay/TransactionVolumeChartSchool.vue')
    },
    {
        path: "school/student-user-statistics",
        component: () => import('@/views/sepay/StudentUserStatistics.vue')
    },
    {
        path: "school/register-shift-subject",
        component: () => import('@/views/attendance-v2/RegisterShiftSubject.vue')
    },
    {
        path: "school/shift-master",
        component: () => import('@/views/attendance-v2/ShiftMaster.vue')
    },
]